<template>
  <div>
    <div class="drafts oa-layout-content">
      <a-table :pagination="false" :columns="columns" :data-source="data">
        <span slot="num" slot-scope="text">{{ text }}台</span>
        <div slot="action">
          <a-button type="link" class="btn-link" @click="add()">
            编辑
          </a-button>
          <a-divider type="vertical" />
          <a-button type="link" class="btn-link"> 删除 </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination :default-current="1" :total="500" @change="pageChange" />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'lot',
    key: 'lot',
    width: 80
  },
  {
    title: '期号',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '简报名称',
    dataIndex: 'age',
    key: 'age'
  },
  {
    title: '拟稿人',
    dataIndex: 'address',
    key: 'address 1',
    ellipsis: true
  },
  {
    title: '拟稿单位',
    dataIndex: 'number',
    key: 'number',
    ellipsis: true
  },
  {
    title: '是否查阅',
    dataIndex: 'ist',
    key: 'ist',
    ellipsis: true
  },
  {
    title: '更新时间',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '表单状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' }
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'center'
  }
]

const data = [
  {
    lot: 1,
    key: '1',
    time: '2017-10-31  ',
    name: '民政公文 2021 五号',
    age: '关于做好英才计划的有关工作的通知',
    number: '编号文',
    address: '王淑英',
    status: 1,
    tags: ['nice', 'developer']
  },
  {
    lot: 2,

    key: '2',
    name: '民政公文 2021 五号',
    time: '2017-10-31',
    number: '编号文',
    age: '关于深刻学习党的精神，不忘初心',
    address: '王淑英',
    status: 2,
    tags: ['nice', 'developer']
  },
  {
    lot: 3,
    key: '333',
    name: '民政公文 2021 五号',
    time: '2017-10-31',
    number: '非编文',
    age: '这是一段描述，关于这个业务',
    address: '王淑英',
    status: 3,
    tags: ['nice', 'developer']
  }
]

export default {
  data() {
    return {
      Form: {
        serialNumber: ''
      },
      data,
      columns
    }
  },
  methods: {
    add() {
      this.$router.push('/addBriefReport')
    },
    pageChange(pageNumber) {
      console.log('Page: ', pageNumber)
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/BriefReport/drafts.vue